import { ChangeDetectionStrategy, Component, computed, input, model } from '@angular/core';
import { IconsEnum, IconSize } from '@/shared/enums';
import { NgClass, NgStyle } from '@angular/common';
import { Icon } from '../icon/icon';

@Component({
  selector: 'bevvi-checkbox',
  imports: [NgClass, NgStyle, Icon],
  templateUrl: './checkbox.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class Checkbox {
  public readonly checked = model(false);
  public readonly label = input('');
  public readonly disabled = input(false);
  public readonly fillColor = input('#C93030');
  public readonly iconColor = input('#FFFFFF');
  public readonly strokeColor = input('#1A1A1A');
  public readonly labelColor = input('#FFFFFF');

  protected readonly checkboxIcon = IconsEnum.CHECKBOX;
  protected readonly iconSize = IconSize.SM;

  protected readonly checkboxStyles = computed(() => ({
    '--checkbox-fill': this.fillColor(),
    '--checkbox-icon': this.iconColor(),
    '--checkbox-stroke': this.strokeColor(),
    '--checkbox-label': this.labelColor(),
  }));

  protected readonly checkboxClasses = computed(() => ({
    'bg-(--checkbox-fill) border-(--checkbox-fill)': this.checked(),
    'bg-transparent border-(--checkbox-stroke)': !this.checked(),
    'opacity-50 cursor-not-allowed': this.disabled(),
  }));
}
